document.addEventListener('DOMContentLoaded', function() {
    // Listen for Klaviyo form events
    window.addEventListener('klaviyoForms', function(event) {
        // Check if the event is a form submission for the specific form ID
        if (event.detail.type === 'submit' && event.detail.formId === 'UeyT5q') {
            callCustomAction();
        }
    });
});

function callCustomAction() {
    // Function to be called after the specific form submission
    const customActionName = 'Sign Up for Texts';
    const proxyUrl = `${window.Rivo.global_config.proxy_paths.loy}/loy/customers/${window.Rivo.common.customer.id}/record_custom_action`;
    const data = {custom_action_name: customActionName};
    fetch(proxyUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function(response) {
            if (response.ok) {
                console.log('Custom action recorded successfully');
            } else {
                console.error('Failed to record custom action');
            }
        })
        .catch(function(error) {
            console.error('Error calling custom action:', error);
        });
}
